// Libs
import React, { HTMLProps, ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './content-card-main-information.module.scss';

/**
 * Main information panel for content card
 * Designed to float alongside a content card image
 * @param props the props
 */
const ContentCardMainInformation = (props: HTMLProps<HTMLDivElement>): ReactElement => (
  <div {...props} className={clsx(styles.container, props.className)} />
);

export default ContentCardMainInformation;
